import cn from 'classnames';
import * as React from 'react';

import Text from '../text';

import { Flag as Props, themes, variants } from './flag.types';

const Flag: React.FunctionComponent<Props> & {
  themes: typeof themes;
  variants: typeof variants;
} = ({ text, theme = themes['inline-block'], variant = variants.featured }) => (
  <div
    className={cn('flag', {
      [`flag--theme-${theme}`]: theme,
      [`flag--variant-${variant}`]: variant,
    })}
  >
    <Text size={Text.sizes.interface} theme={Text.themes.emphasis}>
      {text}
    </Text>
  </div>
);

Flag.themes = themes;
Flag.variants = variants;

export default Flag;
